package constants



import kotlinReactComponents.DropdownMenuStyles.eachEntryStyle
import kotlinReactComponents.DropdownMenuStyles.entryBlockStyle
import kotlinReactComponents.DropdownMenuStyles.titleStyle


data class CompanyName (val companyName: String, val legalForm: String) {
    fun fullNameString(): String {
        return "$companyName $legalForm"
    }
}

data class CompanySloganString (val topLineText: String, val bottomLinesText: String)

data class DropDownMenuEntries (val title: String, val entries: Array<String>, val titleStyle: RuleSetClass, val entryBlockStyle: RuleSetClass, val eachEntryStyle: RuleSetClass) {
    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class.js != other::class.js) return false

        other as DropDownMenuEntries

        if (title != other.title) return false
        if (!entries.contentEquals(other.entries)) return false
        if (titleStyle != other.titleStyle) return false
        if (entryBlockStyle != other.entryBlockStyle) return false
        if (eachEntryStyle != other.eachEntryStyle) return false

        return true
    }

    override fun hashCode(): Int {
        var result = title.hashCode()
        result = 31 * result + entries.contentHashCode()
        result = 31 * result + titleStyle.hashCode()
        result = 31 * result + entryBlockStyle.hashCode()
        result = 31 * result + eachEntryStyle.hashCode()
        return result
    }
}


class CompanyConstants {
    companion object {
        val companyName = CompanyName("Nusquam", "GmbH")
        val companySloganString = CompanySloganString(companyName.companyName, "better Software")
        val dropDownMenuEntriesProdukte = DropDownMenuEntries(
            title = "Produkte und Leistungen",
            entries = arrayOf("Optimierung des Entwicklungsprozesses", "Software Entwicklung"),
            titleStyle = RuleSetClass(titleStyle),
            entryBlockStyle = RuleSetClass(entryBlockStyle),
            eachEntryStyle = RuleSetClass(eachEntryStyle)
        )

        val dropDownMenuEntriesUnternehmen = DropDownMenuEntries(
            title = "Unternehmen",
            entries = arrayOf("Impressum"),
            titleStyle = RuleSetClass(titleStyle),
            entryBlockStyle = RuleSetClass(entryBlockStyle),
            eachEntryStyle = RuleSetClass(eachEntryStyle)
        )

        val navigationElementStyleClass = RuleSetClass(titleStyle)
    }
}